import { Dispatch } from "react";
import styles from "./CartFormCards.module.css";
import { Action } from "../../../Bundles/Types";
import { CartConfigInterface } from "../../CartTypes";
import { FormLayout, Select, TextField } from "@shopify/polaris";
import { FontStyles } from "../../../Bundles/constants";
import CustomInputWithUnit from "../../../../components/CustomInputWithUnit/CustomInputWithUnit";
import NewCustomColorPicker from "../../../../components/NewCustomColorPicker/NewCustomColorPicker";

const CartAdditionalMessageForm = ({
    fields,
    dispatchCartConfig,
    showCartPreview,
}: {
    submit: any;
    fields: any;
    showCartPreview: boolean;
    dispatchCartConfig: Dispatch<Action<CartConfigInterface>>;
}) => {
    const {
        additional_message: {
            additional_msg_text,
            additional_msg_bg,
            additional_msg_color,
            additional_msg_text_size,
            additional_msg_text_style,
        },
    } = fields;

    return (
        <>
            <div className={styles.designCardWrapper}>
                <div className={styles.cardLabel}>General</div>
                <FormLayout>
                    <div className={`${styles.formRow} ${styles.row1}`}>
                        <TextField
                            label={"Announcement Text"}
                            placeholder={"Announcement Text"}
                            autoComplete={"off"}
                            {...additional_msg_text}
                            onBlur={additional_msg_text?.onBlur}
                            onChange={(val) => {
                                dispatchCartConfig({
                                    payload: {
                                        additional_msg_text: val,
                                    },
                                    isComplex: true,
                                    key: "additional_message",
                                });
                                additional_msg_text.onChange(val);
                            }}
                            // maxLength={200}
                            showCharacterCount
                            error={additional_msg_text.error}
                        />
                    </div>
                </FormLayout>
            </div>

            <div className={styles.designCardWrapper}>
                <div className={styles.cardLabel}>Color</div>
                <FormLayout>
                    <div className={`${styles.formRow} ${!showCartPreview && styles.row3}`}>
                        <NewCustomColorPicker
                            hexColor={additional_msg_bg.value}
                            setHexColor={(val) => {
                                additional_msg_bg.onChange(val);
                                dispatchCartConfig({
                                    payload: {
                                        additional_msg_bg: val,
                                    },
                                    isComplex: true,
                                    key: "additional_message",
                                });
                            }}
                            label={"Background Color"}
                            props={{
                                ...additional_msg_bg,
                                onBlur: () => additional_msg_bg?.runValidation(),
                            }}
                        />
                        <NewCustomColorPicker
                            hexColor={additional_msg_color.value}
                            setHexColor={(val) => {
                                additional_msg_color.onChange(val);
                                dispatchCartConfig({
                                    payload: {
                                        additional_msg_color: val,
                                    },
                                    isComplex: true,
                                    key: "additional_message",
                                });
                            }}
                            label={"Message Color"}
                            props={{
                                ...additional_msg_color,
                                onBlur: () => additional_msg_color?.runValidation(),
                            }}
                        />
                    </div>
                </FormLayout>
            </div>
            <div className={styles.designCardWrapper}>
                <div className={styles.cardLabel}>Typography</div>
                <FormLayout>
                    <div className={`${styles.formRow} ${!showCartPreview && styles.row3}`}>
                        <CustomInputWithUnit
                            min={0}
                            label={"Message Size"}
                            placeholder={"Message size"}
                            setValue={(val) => {
                                additional_msg_text_size.onChange(val);
                                dispatchCartConfig({
                                    payload: {
                                        additional_msg_text_size: +val,
                                    },
                                    isComplex: true,
                                    key: "additional_message",
                                });
                            }}
                            value={additional_msg_text_size.value}
                            unitSuffix={"px"}
                            props={{
                                ...additional_msg_text_size,
                                onBlur: () => additional_msg_text_size?.runValidation(),
                            }}
                            error={additional_msg_text_size.error}
                        />
                        <Select
                            label={"Style"}
                            options={FontStyles}
                            placeholder={"Font style"}
                            onChange={(val) => {
                                additional_msg_text_style.onChange(val);
                                dispatchCartConfig({
                                    payload: {
                                        additional_msg_text_style: val,
                                    },
                                    isComplex: true,
                                    key: "additional_message",
                                });
                            }}
                            value={additional_msg_text_style.value}
                        />
                    </div>
                </FormLayout>
            </div>
        </>
    );
};

export default CartAdditionalMessageForm;
